import React, { useContext, useEffect, useState } from "react";
import "../../assets/styles/load-skirts.scss";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuFileUploader from "../../utils/smu-file-uploader/SmuFileUploader";
import { Tree } from "@minoru/react-dnd-treeview";
import SkirtItem from "./parts/SkirtItem";
import _ from "lodash";
import { COLOR_PRIMARY } from "../../constants/colors";
import { StoreContext } from "../../store/StoreContext";
import { fetchFiles, deleteFile, uploadFileByCategory } from "../../api/files";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import Select from "react-select";
import { prepareText } from "../../helpers";
import errorIcon from "../../assets/images/error.png";
import successIcon from "../../assets/images/success.png";
import SmuLoading from "../../utils/smu-loading/SmuLoading";
import SmuButton from "../../utils/smu-button/SmuButton";
import { IconBasket } from "../../icons/Icon";
import SmuTable from "../../utils/smu-table/SmuTable";
import Swal from "sweetalert2";

const acceptedTypes = ["PDF"];
const brand = process.env.REACT_APP_BRAND || "M10";

const LoadSkirts = () => {
  const { skirts, promotions } = useContext(StoreContext);

  const [treeData, setTreeData] = useState([]);
  const [selectedSkirt, setSelectedSkirt] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [multiFiles, setMultiFile] = useState([]);
  const [files, setFiles] = useState([]);
  const [promoErr, setPromoErr] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [summaryModal, setSummaryModal] = useState(false);
  const [summaryUpload, setSummaryUpload] = useState([]);
  const [loading, setLoading] = useState(false);

  const promotion = promotions.find(
    (p) => selectedOption?.value === p.ID_PROMO
  );
  const options = promotions.map((promo) => ({
    label: promo.DESCRIPCION_PROMO,
    value: promo.ID_PROMO,
  }));
  const hnadleFetchFiles = (skirtId) => {
    setLoading(true);
    fetchFiles(skirtId)
      .then(({ data, error }) => {
        if (!!error) throw new Error("Error al traer archivos.");
        setFiles(data?.data?.documents || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast({ icon: "error", title: "Error al traer faldones. Reintente otra vez" });
      });
  };

  useEffect(() => {
    const _skirts = skirts.map((skirt) => ({
      ...skirt,
      droppable: false,
      parent: skirt?.parent || 0,
    }));
    setTreeData(_skirts);
  }, [skirts]);

  useEffect(() => {
    if (!selectedSkirt?.id) return;
    hnadleFetchFiles(selectedSkirt.id);
  }, [selectedSkirt?.id]);

  useEffect(() => {
    if (summaryModal) return;
    setSummaryUpload([]);
  }, [summaryModal]);

  const makePath = (_skirt) => {
    let result = [];

    skirts.forEach((s, i) => {
      if (s.id === _skirt.parent) {
        let _skirts = makePath(s);
        result = [...result, s, ..._skirts];
      }
      result = [...result, _skirt];
    });

    return _.uniqBy(result, "id");
  };

  const handleChoseSkirt = (_skirt) => {
    if (selectedSkirt?.id === _skirt.id) {
      setSelectedSkirt(null);
      setBreadcrumbs([]);
      return;
    }

    setSelectedSkirt(_skirt);
    const __skirts = makePath(_skirt);
    const _breadcrumbs = __skirts.map((_skirt) =>
      _skirt.title.replace("/", "")
    );
    setBreadcrumbs(_breadcrumbs.reverse());
  };

  const handleUploadFile = async () => {
    if (!promotion?.ID_PROMO) {
      setPromoErr(true);
      return { error: true };
    }
    setPromoErr(false);

    const file = filesToUpload[0];
    if (!file)
      return toast({
        icon: "error",
        title: "No fue posible cargar el archivo.",
      });

    const metadata = { fileName: file.name };
    const formData = new FormData();
    formData.append("document", file, file.name);
    formData.append("category", selectedSkirt?.id);
    formData.append("metadata", JSON.stringify(metadata));
    formData.append("promotion_id", promotion.ID_PROMO);
    formData.append("filetype", "Faldon");

    const result = await uploadFileByCategory(formData);
    if (!selectedSkirt?.id) return;
    hnadleFetchFiles(selectedSkirt.id);
    return result;
  };

  const handleUploadFileMultiple = () => {
    return new Promise((resolve, reject) => {
      Promise.allSettled(
        multiFiles.map((file) => {
          const nameSplit = file.name.split("-");
          const lastIndex = nameSplit.length - 1;

          
          let brandName = null;
          let _skirts = [];
          nameSplit.forEach((segment, index) => {
            const validation =
              index < lastIndex &&
              segment.length === 3 &&
              !segment.includes(" ") &&
              !segment.includes(".");
            if (index === 0) brandName = segment;
            else if (validation) _skirts.push(segment);
          });

          

          const _promo = promotions.find((p) => {
            const description = prepareText(p.DESCRIPCION_PROMO);
            const _promotionName = prepareText(file.name);
            return _promotionName.includes(description);
          });
          const _skirt = skirts.find(s => _skirts.join("-") === s.code );
          //console.log(nameSplit);
          //console.log(lastIndex);
          //return;
          if (lastIndex <= 1 || !_skirt)
            return Promise.reject("MENU-NOT-FOUND");
          else if (brandName !== brand) 
            return Promise.reject("NO-BRAND");
          else if (!_promo) 
            return Promise.reject("NOT-FOUND-PROMOTION");

          const metadata = { fileName: file.name };
          const formData = new FormData();
          formData.append("document", file, file.name);
          formData.append("category", _skirt?.id);
          formData.append("metadata", JSON.stringify(metadata));
          formData.append("promotion_id", _promo.ID_PROMO);
          formData.append("filetype", "Faldon");
          
          return uploadFileByCategory(formData);
        })
      )
        .then((response) => {
          const _summary = multiFiles.map((file, index) => {
            const _s = {
              fileName: file.name,
              status: "success",
              message: "Carga completa.",
              icon: successIcon,
            };
            const res = response[index];
            if (res?.status === "rejected") {
              _s.status = "error";
              _s.icon = errorIcon;
              switch (res?.reason) {
                case "MENU-NOT-FOUND":
                  _s.message = "No logró asociar un menu al archivo.";
                  break;
                case "NO-BRAND":
                  _s.message =
                    "EL portar indicado en el archivo no corresponde.";
                  break;
                case "NOT-FOUND-PROMOTION":
                  _s.message = "No logró asociar una promoción al archivo.";
                  break;
                default:
                  _s.message = "Error en la lectura del archivo.";
                  break;
              }
            }
            return _s;
          });
          setSummaryUpload(_summary);
          setSummaryModal(true);

          resolve(_summary);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const handleDelete = (fileId) => {
    Swal.fire({
      title: "¿Deseas eliminar este faldon?",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      confirmButtonColor: COLOR_PRIMARY,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      deleteFile(selectedSkirt.id, fileId)
        .then(({ error }) => {
          if (!!error) throw new Error(error?.message);
          toast({ icon: "success", title: "Documento eliminado." });
        })
        .catch((err) => {
          console.error(err);//toast({ icon: "error", title: err });
        })
        .finally(() => {
          hnadleFetchFiles();
        });
    });
  };

  const columns = [
    {
      name: "Nombre de archivo",
      selector: (row) => row.filename,
      sortable: true,
      cell: (row) => <div className="cell text-truncate">{row.filename}</div>,
      width: "60%",
    },
    {
      name: "Visualizaciones",
      selector: (row) => row.views,
      sortable: true,
      cell: (row) => <div className="cell text-center">{row.views}</div>,
      width: "30%",
    },
    {
      name: "",
      width: "10%",
      selector: (row) => row.id,
      cell: (row) => (
        <div className="cell w-100 d-flex">
          <SmuButton
            _className="ms-auto"
            control={() => handleDelete(row.id)}
          >
            <IconBasket color="#33383F" />
          </SmuButton>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        show={summaryModal}
        onHide={() => setSummaryModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Resumen de carga
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {summaryUpload.map((summary, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              <img src={summary.icon} alt="RESPONSE" height={25} width={25} />
              <div className="ms-2" style={{ whiteSpace: "nowrap" }}>
                {summary.fileName}:
              </div>
              <p
                className={`ms-3 mb-0 ${
                  summary.status === "error" ? "text-danger" : "text-success"
                }`}
              >
                {summary.message}
              </p>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setSummaryModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Card className="smu-card">
        <Card.Header className="d-flex align-items-center py-4">
          <div className="d-flex align-items-center">
            <SmuBadge color="#FFD88D" />
            <span className="fs-5 ms-3 me-auto">Cargar Faldones</span>
          </div>
        </Card.Header>

        <Card.Body>
          <div className="h6 mb-4">Selecciona una sección</div>

          <Row>
            <Col col={12} lg={6}>
              <Tree
                canDrop={() => false}
                tree={treeData}
                rootId={0}
                classes={{ root: "skirt-list" }}
                render={(node, { depth, isOpen, onToggle, hasChild }) => (
                  <SkirtItem
                    node={node}
                    depth={depth}
                    isOpen={isOpen}
                    onToggle={onToggle}
                    hasChild={hasChild}
                    active={selectedSkirt?.id === node.id}
                    choseSkirt={(val) => handleChoseSkirt(val)}
                  />
                )}
              />
            </Col>
            <Col col={12} lg={6}>
              <div className="youre-in mb-1">Estas en:</div>
              <div className="breadcrumbs">
                Faldones / {breadcrumbs.join(" / ")}
              </div>

              {selectedSkirt?.id ? (
                <>
                  <div className="my-3">
                    <div className="youre-in mb-1">Promociones:</div>
                    <Form.Group>
                      <Select
                        value={selectedOption}
                        onChange={setSelectedOption}
                        options={options}
                        noOptionsMessage={() =>
                          "No se encontraron coincidencias"
                        }
                      />
                      {promoErr && (
                        <small className="text-danger">
                          Este campo es requerido.
                        </small>
                      )}
                    </Form.Group>
                  </div>
                  <SmuFileUploader
                    uploadFile={handleUploadFile}
                    acceptedTypes={acceptedTypes}
                    files={filesToUpload}
                    setFiles={setFilesToUpload}
                  />
                </>
              ) : promotions.length > 0 ? (
                <SmuFileUploader
                  uploadFile={handleUploadFileMultiple}
                  acceptedTypes={acceptedTypes}
                  files={multiFiles}
                  setFiles={setMultiFile}
                  multiple={true}
                  needPromo={true}
                  verifyPrefix={true}
                />
              ) : (
                <div className="my-4">
                  <SmuLoading label="Cargando promociones..." />
                </div>
              )}

              <br/>
              
              <SmuTable
                columns={columns}
                data={files}
                paginationPerPage={6}
                loading={loading}
              /> 

             
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default LoadSkirts;
